GP.GPMod('ImageFilters',function(self){
    var vent   = null;
    var _util  = null;
    var _log   = null;

    var _data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            _util  = self.app.Util;
            _log   = self.app.Util.log;
        },
        canvas: null,
        filtered_canvas: null,
        caman_main: null,
        rendering: false,
        photo_filters: {},
        is_private: false
    };

    var gui = {
        init: function() {
            this.$caman_hidden           = $('#caman-hidden');
            this.$result_image           = $('#caman-result');
            this.$preset_filters_cont    = $('#preset-filters');
            this.$btn_save               = $('#caman-submit');
            this.$result_image_container = $('#caman-image-container');
            this.$btn_new_filter         = $('.btn-new-filter');
            this.$btn_save_wrap          = $('.btn-save-wrap');
            this.$filter_success         = $('.filter-success');
            this.$filter_errors          = $('.filter-errors');
            this.$header_thumbnails      = $('#mem-photo-t, #mem-photo-s');
        }
    };

    var apis = {
        save_photo: function() {
            events.hide_errors();
            gui.$btn_save.prop('disabled', true);

            // show spinner
            gui.$preset_filters_cont.spin();

            var post_params = {
                process: true,
                image: _data.caman_main.toBase64(),
                content_id: gui.$result_image.data('content_id')
            };

            if (_data.is_private) {
                post_params.private = 1;
            }

            $.post('/members/content/filters', post_params)
             .done(function(json) {
                // stop spinner
                gui.$preset_filters_cont.spin(false);

                if (json.success) {

                    // cache bust new filtered photo
                    setTimeout(function() {
                        document.getElementById("filter-photo-frame").contentWindow.location.reload(true);
                    }, 500);

                    // Update nav thumbs if primary photo
                    if (json.photo.media_main_pic == 'Y') {
                        if (gui.$header_thumbnails) {
                            var active_thumb = $('.filter-preview-wrap.active').find('.filter-image');
                            gui.$header_thumbnails.attr('src', active_thumb.prop('src'));
                        }
                    }

                    events.show_success();
                } else if (json.result.error) {
                    events.show_errors(json.result.error);
                }
            });
        }
    };

    var events = {
        init: function() {
            vent.on(self.moduleName + ':init_filters', events.init_filters);
        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();
            gui.$btn_save.on('click', apis.save_photo);
            gui.$btn_new_filter.on('click', events.hide_success);
        },
        init_filters: function(photo_filters, photo_urls, is_private) {
            _data.photo_filters = photo_filters;

            var img_sm = events.create_img_obj(photo_urls.S);
            var img_lg = events.create_img_obj(photo_urls.L);

            if (typeof is_private !== 'undefined' && is_private) {
                _data.is_private = true;
            }

            events.setup_binds();

            _data.canvas = document.createElement('canvas');
            _data.filtered_canvas = document.createElement('canvas');

            gui.$caman_hidden.append(_data.canvas).append(_data.filtered_canvas);

            events.show_main_preview(img_lg);
            events.show_filter_previews(img_sm);
        },
        show_main_preview: function(img_obj) {
            _data.caman_main = Caman(img_obj, function () {
                events.render_main_photo();
            });
        },
        show_filter_previews: function(img_obj) {
            var $template = $(".image-filter-template");
            gui.$preset_filters_cont.spin();

            for (var i = 0; i < _data.photo_filters.length; i++) {
                // Add placeholders first
                var $clone = $template.clone();
                $clone.attr('data-filter', _data.photo_filters[i].key);
                $clone.on('click', events.select_filter);

                gui.$preset_filters_cont.append($clone);
                events.render_previews(_data.photo_filters[i], img_obj);
            }
        },
        render_previews: function(filter, img_obj) {
            Caman(img_obj, function () {
                // revert canvas back to original state
                this.revert(false);

                // apply filter
                if (_util.check_callable(this[filter.key]) && filter.key !== 'original') {
                    this[filter.key]();
                }

                this.render(function () {
                    var $placeholder = gui.$preset_filters_cont.find('[data-filter=' + filter.key + ']');
                    $placeholder.removeClass('hide')
                                .find('.filter-image').prop('src', this.toBase64());
                    $placeholder.find('.text-filter-name').text(filter.name);

                    // default to "no filter"
                    if (filter.key == 'original') {
                        $placeholder.addClass('active');
                    }

                    // this filter takes the longest to render
                    if (this.id == 22) {
                        gui.$preset_filters_cont.spin(false);
                    }
                });
            });
        },
        render_main_photo: function() {
            _data.caman_main.render(function() {
                gui.$result_image.prop('src', this.toBase64());
                _data.rendering = false;

                // stop spinner
                gui.$result_image_container.spin(false);
            });
        },
        select_filter: function(e) {
            if (!_data.rendering) {
                $('.filter-preview-wrap').removeClass('active');
                events.hide_errors();
                $(e.currentTarget).addClass('active');
                var filter_name =  $(e.currentTarget).data('filter');
                
                // revert main photo back to original state
                _data.caman_main.revert(false);

                if (filter_name !== 'original') {
                    // show spinner
                    gui.$result_image_container.spin({color:'#fff'});

                    _data.rendering = true;
                    _data.caman_main[filter_name]();
                }
                events.render_main_photo();
            }
        },
        create_img_obj: function(photo_url) {
            var img = new Image();
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            var src = photo_url;

            img.crossOrigin = "Anonymous";
            img.onload = function() {
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage( img, 0, 0 );
                localStorage.setItem( "savedImageData", canvas.toDataURL("image/png") );
            };
            img.src = src;
            // make sure the load event fires for cached images too
            if ( img.complete || img.complete === undefined ) {
                img.src = "data:image/jpg;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
                img.src = src;
            }
            return img;
        },
        show_success: function() {
            gui.$filter_success.removeClass('hide');
            events.hide_errors();
            gui.$preset_filters_cont.css('visibility', 'hidden');
            gui.$btn_save_wrap.hide();
        },
        hide_success: function() {
            gui.$filter_success.addClass('hide');
            gui.$preset_filters_cont.css('visibility', 'visible');
            gui.$btn_save_wrap.show();
            gui.$btn_save.prop('disabled', false);
        },
        show_errors: function(text_error) {
            gui.$filter_errors.removeClass('hide');
            $('.filter-error-text').text(text_error);
            gui.$btn_save.prop('disabled', false);
        },
        hide_errors: function() {
            gui.$filter_errors.addClass('hide');
        }
    };

    this.addInitializer(function(){
        _data.init();
        events.init();
    });
});
